// ============================================================================
// HOOK: useCadernoApproval — Fluxo de envio de peça para aprovação do cliente
// ARQUIVO: src/hooks/useCadernoApproval.js
// RESPONSABILIDADE: Isolar estado e lógica de approval do CadernoCockpit.
// ============================================================================

import { useState } from 'react';
import { sendPieceForApproval } from '../services/CadernoApprovalRepository';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export function useCadernoApproval({ activeWorkspace, selectedClientId, hubBridge }) {
  const [approvalModalPiece, setApprovalModalPiece] = useState(null);
  const [approvalNote, setApprovalNote] = useState('');
  const [sendingApproval, setSendingApproval] = useState(false);
  const [approvalNotice, setApprovalNotice] = useState('');
  const [consentBuilderPiece, setConsentBuilderPiece] = useState(null);

  const handleSendForApproval = async (piece) => {
    if (!piece?.id || !activeWorkspace?.id) return;
    const cid = String(activeWorkspace?.clientId || selectedClientId || '').trim();
    if (!cid) { setApprovalNotice('Sem cliente vinculado ao caderno.'); return; }
    setSendingApproval(true);
    try {
      await sendPieceForApproval({
        clientId:      cid,
        workspaceId:   String(activeWorkspace.id),
        workspaceName: String(activeWorkspace?.alias || activeWorkspace?.name || 'Caderno'),
        pieceId:       String(piece.id),
        pieceType:     String(piece.pieceType || 'Documento'),
        driveUrl:      String(hubBridge?.driveUrl || ''),
        lawyerNote:    approvalNote.trim(),
        status:        'pending',
        clientNote:    '',
      }, appId);
      setApprovalNotice('Peça enviada para aprovação do cliente!');
      setTimeout(() => setApprovalNotice(''), 3000);
      setApprovalModalPiece(null);
      setApprovalNote('');
    } catch (e) {
      setApprovalNotice('Erro ao enviar: ' + String(e?.message || e).slice(0, 80));
    }
    setSendingApproval(false);
  };

  const showApprovalNotice = (msg, duration = 3000) => {
    setApprovalNotice(msg);
    setTimeout(() => setApprovalNotice(''), duration);
  };

  return {
    approvalModalPiece, setApprovalModalPiece,
    approvalNote, setApprovalNote,
    sendingApproval, setSendingApproval,
    approvalNotice, setApprovalNotice,
    consentBuilderPiece, setConsentBuilderPiece,
    handleSendForApproval,
    showApprovalNotice,
  };
}
